import PropTypes from 'prop-types'

// Synos symbol: two fronts of dots sharing a central seam. Geometry from the
// brand SVGs (viewBox -48 -40 96 80). `fill="white"` (used on dark headers)
// switches to the negative variant, as the brand's symbol-negative.svg does.
const Logomark = ({ style, fill }) => {
  const negative = fill === 'white' || fill === '#fff' || fill === '#FFF'
  const seam = negative ? '#FAF7F2' : '#14313D'
  const a = negative ? '#56A9AC' : '#2E7D80'
  const b = negative ? '#EAB463' : '#E0A24E'
  return (
    <svg
      width="26"
      viewBox="-48 -40 96 80"
      style={style}
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg">
      {[-20, 0, 20].map((y) => (
        <circle key={'s' + y} cx="0" cy={y} r="5.5" fill={seam} />
      ))}
      {[[-24, -30], [-38, -10], [-38, 10], [-24, 30]].map(([x, y]) => (
        <circle key={'a' + x + y} cx={x} cy={y} r="6.5" fill={a} />
      ))}
      {[[24, -30], [38, -10], [38, 10], [24, 30]].map(([x, y]) => (
        <circle key={'b' + x + y} cx={x} cy={y} r="6.5" fill={b} />
      ))}
    </svg>
  )
}

Logomark.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string
}

export default Logomark
